import { CommonModule } from '@angular/common';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { ArrowBackComponent } from 'app/modules/GlobalComponents/arrow-back.component';
import { FormDescargarReporteComponent } from './form-descargar-reportes/form-descargar-reportes.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { REPORTES } from './reportes-data';
import { UtilsService } from 'app/modules/utils-service';
import { SeccionBienesCulturales } from 'app/models/datos-navegacion-solicitudes-gestiones';

@Component({
    selector: 'app-reportes',
    templateUrl: 'reportes.component.html',
    imports:[
        CommonModule,
        MatButtonModule,
        MatRadioModule,
        FormsModule,
        
        ArrowBackComponent,
        FormDescargarReporteComponent
    ]

})

export class ReportesComponent implements OnInit {
    REPORTES = REPORTES;
    reporteSeleccionado:string
    seccionBienes:number
    tipoReporte:string = 'bienes-culturales'
    nombreSeccion:string = ''

    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private utilsService: UtilsService
    ) { 
        console.log(this.utilsService.seccion_uuid_value)
    }

    ngOnInit() {
        this.route.paramMap
            .pipe(takeUntil(this.destroy$))
            .subscribe(params => {
                const seccionUuid = params.get('seccion_uuid');
                this.seccionBienes= seccionUuid ? +seccionUuid:undefined
                this.onSeleccionarReporte(this.REPORTES[0].tipo)     
                
                const seccion = SeccionBienesCulturales.find(item => item.seccion === this.seccionBienes);
                this.nombreSeccion = seccion.titulo
        });
    }

    onSeleccionarReporte(valor: string) {
        this.reporteSeleccionado = valor;
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { reporte: valor },
            queryParamsHandling: 'merge'
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

}